import React, { Fragment, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import "../Components/styles/CheckoutForm.css";
import "../Components/styles/launcherPageComponent.css";
import CheckoutForm from "../Components/checkoutPageComponent/checkoutForm";
import { FooterSection } from "../Components/LauncherPageComponent/launcherPageComponent";
import SDK from "../config";
import { imagesLinks } from "../Constants/links";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_LIVE);

const CheckOutPage = () => {
  const [cardBoxPosition, setCardBoxPosition] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const region = localStorage.getItem("region") || "us";

  useEffect(() => {
    const updateScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 830);
    };
    window.addEventListener("resize", updateScreenSize);
    updateScreenSize();
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  const location = useLocation();
  const isReservationRoute =
    location.pathname === "/payment-checkout" ||
    location.pathname === "/uk/payment-checkout" ||
    location.pathname === "/eu/payment-checkout";

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 830);

  const regionClass = region !== "us" ? "region-other" : "";

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 830);
    };

    // Initial check when the component mounts
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <Fragment>
        <div style={{ overflow: "hidden" }}>
          <div className="reservation_page">
            <div className="text_part">
              <div className="reservation_logo">
                <div>
                  <img src={imagesLinks.logo} className="navLogo" alt="" />
                </div>
              </div>

              <CheckoutForm setCardBoxPosition={setCardBoxPosition} />
            </div>

            <div
              className={`cards_part ${
                isReservationRoute ? "reservation-checkout" : ""
              } ${regionClass}`}
            >
              <div
                className={`img_text_box ${
                  isSmallScreen && cardBoxPosition ? "move-up-small" : ""
                }`}
              >
                <div className="card-img-text-box">
                  <div className="card-team-img">
                    <img src={imagesLinks.iphoneMockup} alt="" />
                  </div>
                  <div className="card-text-box">
                    <div className="card-text-first-box">
                      <p>
                        Join 15,000+ others who have reclaimed control over
                        their phones:
                      </p>
                    </div>
                    <div className="card-text-second-box">
                      <ul>
                        <li>
                          <span className="bold-text">‘Am loving it!’</span> -
                          Gavin
                        </li>
                        <li>
                          <span className="bold-text">
                            ‘I love love love the aesthetic’
                          </span>
                          - Ryan
                        </li>
                        <li>
                          <span className="bold-text">
                            ‘The aesthetic is just *chefs kiss*’
                          </span>
                          - Mary
                        </li>
                        <li>
                          <span className="bold-text">
                            ‘Such a great idea and design!’
                          </span>
                          - Geoff
                        </li>
                        <li>
                          <span className="bold-text">
                            '..more time with my wife and kids'
                          </span>
                          - Dennis
                        </li>
                        <li>
                          <span className="bold-text">
                            ‘Such a game changer for us iOS folks!’
                          </span>
                          - Mary
                        </li>
                        <li>
                          <span className="bold-text">
                            'I really love it, it looks fantastic'
                          </span>
                          - Rebecca
                        </li>
                        <li>
                          <span className="bold-text">
                            'I just wanted to say how terrific it is...extremely
                            clever..'
                          </span>
                          - Jamie
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className={`reservation_crad_box cards_part ${
                    isReservationRoute ? "reservation_checkout_box" : ""
                  } ${regionClass}`}
                >
                  <div className="card1">
                    <div className="card_icon">
                      <img src={imagesLinks.c1} alt="" />
                    </div>
                    <div className="card_text">
                      <p className="card_p1">
                        Lock in a massive lifetime discount
                      </p>
                      <p className="card_p2">
                        Today's your lucky day - we charge $49.99 yearly on the
                        app store!
                      </p>
                    </div>
                  </div>
                  <div className="card1">
                    <div className="card_icon">
                      <img src={imagesLinks.c2} alt="" />
                    </div>
                    <div className="card_text">
                      <p className="card_p1">Full refund guarantee</p>
                      <p className="card_p2">
                        Not a fan? No problem. Email us for a full refund within 7 days.
                      </p>
                    </div>
                  </div>
                  <div className="card1 card-bottom">
                    <div className="card_icon">
                      <img src={imagesLinks.c3} alt="" />
                    </div>
                    <div className="card_text">
                      <p className="card_p1">Payment secured by Stripe</p>
                      <p className="card_p2">
                        The same payment processor Apple, Amazon, Etsy, Walmart
                        & Target use. No credit card details seen or stored by
                        us!
                      </p>
                    </div>
                  </div>
                  {isMobileView && (
                    <div className="footer_section">
                      <FooterSection />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!isMobileView && (
            <div className="footer_section">
              <FooterSection />
            </div>
          )}
        </div>
      </Fragment>
    </Elements>
  );
};

export default CheckOutPage;
